import { render, staticRenderFns } from "./ElderlyInsCheckIn2.vue?vue&type=template&id=7630d936&scoped=true&"
import script from "./ElderlyInsCheckIn2.vue?vue&type=script&lang=js&"
export * from "./ElderlyInsCheckIn2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7630d936",
  null
  
)

export default component.exports